import { Api } from "../api";
import { getProductsPhotos } from "./index";

export function buildElectricsFilter({ marka, model, kuzov }) {
  const filter = {};
  if (marka) filter.marka = [marka];
  if (model) filter.model = [model];
  if (kuzov) filter.kuzov = [kuzov];
  return filter;
}

export function formatSelectedElectrics(product) {
  const photos = getProductsPhotos(product);
  return {
    id: product.ID,
    name: product.NAME,
    price: product.CATALOG?.MIN_PRICE || 0,
    image: photos?.[0]?.small,
    product,
  };
}

export async function fetchElectricsProducts(product) {
  const marka = product.MARKA?.CODE_ALT;
  const model = product.MODEL?.CODE_ALT;
  const kuzov = product.KUZOV?.CODE_ALT;
  const filter = buildElectricsFilter({ marka, model, kuzov });
  const isFarkop = String(product.IBLOCK_SECTION_ID) === "635";
  const response = await Api.server.getCatalog(
    {
      params: {
        sectionId: isFarkop ? 636 : 635,
        pageNum: 1,
      },
      filter,
    },
    false,
  );
  return response?.products || [];
}
